import { Table, Modal, Form, Row, Col } from "react-bootstrap";
import { useState, useContext, useEffect } from "react";
import axios from "axios";
import "../components/Reminder.css";
import { API_URL } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import Button from "@mui/material/Button";
import SelectUser from "../components/SelectUser";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import "dayjs/locale/pl";
import { pl } from "date-fns/locale";
import { format } from "date-fns";

export default function DataTable({ data = [], onUpdate, buttonAll, onEdit }) {
  const [comment, setComment] = useState(null);
  const { userData } = useContext(UserDataContext);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [editTask, setEditTask] = useState({
    id: null,
    content: "",
    datetask: "",
  });
  const [deleteTask, setDeleteTask] = useState({
    id: null,
    content: "",
    datetask: "",
  });

  const handleComment = (e) => {
    setComment(e.target.value);
  };
  const handleCloseEditModal = () => setShowEditModal(false);
  const handleShowEditModal = (task) => {
    setEditTask(task);
    setShowEditModal(true);
  };

  const handleShowDeleteModal = (task) => {
    setDeleteTask(task);
    setShowDeleteModal(true);
  };

  const handleEdit = (id) => {
    const task = data.find((item) => item.id === id);
    if (task) {
      handleShowEditModal({
        id: task.id,
        content: task.content,
        datetask: task.datetask,
      });
    }
  };

  const handleDelete = (id) => {
    const task = data.find((item) => item.id === id);
    if (task) {
      handleShowDeleteModal({
        id: task.id,
        content: task.content,
        datetask: task.datetask,
      });
    }
    //console.log(task);
  };

  const handleSaveEdit = async () => {
    //console.log(editTask.datetask);
    try {
      const response = await axios.put(
        `${API_URL}/updateListTask/${userData.cookie}`,
        {
          id: editTask.id,
          content: editTask.content,
          datetask: editTask.datetask,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      //console.log("Response: ", response.data);
      setShowEditModal(false);
      onUpdate(editTask.id);
    } catch (error) {
      console.error("Błąd podczas edytowania elementu:", error);
    }
  };

  const handleClose = () => setShowDeleteModal(false);

  const sortedData = Array.isArray(data)
    ? [...data].sort((a, b) => {
        if (sortConfig.key === null) return 0;
        const direction = sortConfig.direction === "asc" ? 1 : -1;

        if (a[sortConfig.key] < b[sortConfig.key]) {
          return -1 * direction;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return 1 * direction;
        }
        return 0;
      })
    : [];

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleDeleteItem();
    }
  };
  const handleValueChange = (value) => {
    setSelectedValue(value);
    //console.log("user: ", value);
  };

  const handleDeleteItem = async (id) => {
    try {
      await axios.put(
        API_URL + `/update/${userData.cookie}`,
        { id: deleteTask.id, comment: comment },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      onUpdate(deleteTask.id);
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Błąd podczas usuwania elementu:", error);
    }
  };

  useEffect(() => {
    const updateTaskUser = async () => {
      let url = API_URL + `/changetaskuser/${userData.cookie}`;
      if (selectedValue.value > 0) {
        try {
          await axios.post(url, selectedValue, {
            headers: {
              "Content-Type": "application/json",
            },
          });
        } catch (error) {
          console.error("Błąd podczas aktualizacji zadania", error);
        }
      }
    };

    updateTaskUser();
  }, [selectedValue, userData.cookie, userData.userId]);

  return (
    <div>
      {/* Modal do edycji */}
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pl}>
        <Modal show={showEditModal} onHide={handleCloseEditModal}>
          <Modal.Header closeButton>
            <Modal.Title>Edytuj Zadanie [ ID: {editTask.id} ]</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Treść</Form.Label>
                <Form.Control
                  type="text"
                  value={editTask.content}
                  onChange={(e) =>
                    setEditTask({ ...editTask, content: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3">
                Termin:<br></br>
                <DatePicker
                  label="Data realizacji"
                  value={editTask.datetask ? new Date(editTask.datetask) : null}
                  onChange={(newValue) => {
                    setEditTask({ ...editTask, datetask: newValue });
                  }}
                  format="yyyy-MM-dd"
                  slotProps={{ textField: { variant: "outlined" } }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Row>
              <Col>
                <Button variant="outlined" onClick={handleCloseEditModal}>
                  Anuluj
                </Button>
              </Col>
              <Col>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSaveEdit}
                >
                  Zapisz
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>
      </LocalizationProvider>
      {/* Modal do usuwania */}
      <Modal show={showDeleteModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Oznacz jako wykonane [ID: {deleteTask.id} ]</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Czy na pewno chcesz usunąć ten element?<br></br>
          <br></br>
          <b>{deleteTask.content}</b>
          <br></br>
          Termin: <b>{deleteTask.datetask}</b>
        </Modal.Body>
        <Modal.Body>
          <Form>
            <Form.Group
              className="mb-3"
              controlId="closedComment.ControlInput1"
            >
              <Form.Label>Komentarz zamknięcia</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                onChange={handleComment}
                onKeyDown={handleKeyDown}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col>
              <Button variant="outlined" onClick={handleClose}>
                Anuluj
              </Button>
            </Col>
            <Col>
              <Button variant="contained" onClick={handleDeleteItem}>
                Usuwam
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th className="td-centered">ID</th>
            <th>Utworzył</th>
            <th>Treść</th>
            <th>Termin</th>
            <th>Ile dni</th>
            <th>Zmień wykonawcę</th>
            <th>Edytuj</th>
            <th>Usuń</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => (
            <tr key={index}>
              <td data-label="ID">{index + 1}</td>
              <td data-label="Utworzyła">{item.fullName}</td>
              {item.delay === "1" ? (
                <td
                  data-label="Temat"
                  style={{
                    textDecoration: "underline",
                    textDecorationColor: "red",
                    textDecorationThickness: "3px",
                    backgroundColor:
                      item.daytoday === "1" ? "#FFBF00" : "transparent",
                  }}
                >
                  <div>{item.content}</div>
                  {item.closedComments && (
                    <div className="red-text">{item.closedComments}</div>
                  )}
                </td>
              ) : (
                <td
                  data-label="Temat"
                  style={{
                    backgroundColor:
                      item.daytoday === "1" ? "#FFBF00" : "transparent",
                  }}
                >
                  <div>{item.content}</div>
                  {item.closedComments && (
                    <div className="red-text">{item.closedComments}</div>
                  )}
                </td>
              )}
              <td data-label="Termin">{item.datetask}</td>
              <td data-label="Czas trwania zadania [dni]">{item.created}</td>
              {buttonAll === "Aktualne" && (
                <>
                  <td data-label="Kiedy zakończone">{item.deletedDate}</td>
                  <td data-label="Kto zamknął">{item.deletedWho}</td>
                </>
              )}
              {((userData && userData.helper === "1") ||
                userData.grpAdmin === "1") && (
                <td data-label="Zmień właściciela">
                  {item.deleted === null && (
                    <SelectUser
                      onValueChange={handleValueChange}
                      itemId={item.id}
                    />
                  )}
                </td>
              )}
              <td>
                {item.deleted === null && (
                  <Button
                    variant="outlined"
                    color="success"
                    onClick={() => handleEdit(item.id)}
                  >
                    <i className="fa fa-edit" aria-hidden="true"></i>
                  </Button>
                )}
              </td>
              <td>
                {item.deleted === null && (
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => handleDelete(item.id)}
                  >
                    <i className="fa fa-trash" aria-hidden="true"></i>
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
